import { useIntl } from "react-intl"
import { InputDate } from "medere-ui-framework"
import { useState, useEffect } from "react"
import { getAppointmentList, openNotes, openButtons, getAppointmentListSpeciality } from "../servicesHooks/Appointment/useAppointmentReactService"
import Collapsible from "../components/Collapsible/Collapsible";
import { TurnCard } from "../components/TurnCard/TurnCard";
import { AppointmentsDTO } from '../interface/interface';
import { useSearchParams } from "react-router";

export default function CollapsiblePanel() {
  //TODO Tomás: Implementar la obtención de los datos del profesional y especialidad, además del showAppointments y type

  const [searchParams] = useSearchParams();
  const professionalId: number = Number(searchParams.get('professionalID'));
  const specialityId: number = Number(searchParams.get('specialityID'));
  const sessionId: string = searchParams.get('sessionID') || '';
  const showAppointments: number = Number(searchParams.get('number'));
  const type: number = Number(searchParams.get('typeID'));

  console.log("professionalId: ", professionalId, " specialityId: ", specialityId, " showAppointments: ", showAppointments, " type: ", type);

  /*const [professionalId, setProfessionalId] = useState<number>(-1);         //comentado hasta que se pase todo a react
  const [specialityId, setSpecialityId] = useState<number>(-1);
  const [showAppointments, setShowAppointments] = useState<number>(-1);
  const [type, setType] = useState<number>(-1);*/

  /*useEffect(() => {
      //Acá se hace la request a la API para obtener los datos
      setProfessionalId(-1);
      setSpecialityId(-1);
      setShowAppointments(-1);
      setType(-1);
  }, []);*/

  const intl = useIntl();
  const addDays = (date: Date, days: number): Date => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };
  const today = generateFromDateCollapsible(new Date())
  const [initialDateTime, setInitialDateTime] = useState<Date>(today);
  const [finalDateTime, setFinalDateTime] = useState<Date | null>(addDays(today, 1));
  const [title, setTitle] = useState<string>();
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const [selected, setSelected] = useState(false);

  const [appointments, setAppointments] = useState([]);

  const weekDayNames = [
    'DOMINGO', 'LUNES', 'MARTES', 'MIÉRCOLES', 'JUEVES', 'VIERNES', 'SÁBADO'
  ];
  const shortMonthNames = [
    'ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'
  ];

  const options = [
    { id: 1, text: 'Elegir fecha' },
    { id: 2, text: 'Fecha actual' },
    { id: 3, text: 'Próximos 5 días' },
    { id: 4, text: 'Próximos 15 días' },
    { id: 5, text: 'Mes en curso' },
    { id: 6, text: 'Todas las fechas con turnos' }
  ];

  const generateDateFirstDayOfMonth = () => {
    return new Date(today.getFullYear(), today.getMonth(), 1);
  };

  const handleSelectOption = (selectedOption: any) => {

    if (selectedOption.id != 1) {
      setShowDatePicker(false);
      setSelected(false)
    }

    switch (selectedOption.id) {
      case 1:
        //fecha de eleccion
        setShowDatePicker(true);
        setSelected(true)
        break;
      case 2:
        // Opción 'Fecha actual'
        setInitialDateTime(today);
        setFinalDateTime(addDays(today, 1));
        setTitle("HOY, " + generateTitleDate(today))
        break;
      case 3:
        // Opción 'Próximos 5 días'
        setInitialDateTime(today);
        setFinalDateTime(addDays(today, 6));
        setTitle("DE " + generateTitleDate(today) + " A " + generateTitleDate(addDays(today, 5)))
        break;
      case 4:
        // Opción 'Próximos 15 días'
        setInitialDateTime(today);
        setFinalDateTime(addDays(today, 16));
        setTitle("DE " + generateTitleDate(today) + " A " + generateTitleDate(addDays(today, 15)))
        break;
      case 5:
        // Opción 'Mes en curso'
        const firstDayOfMonth = generateDateFirstDayOfMonth();
        setInitialDateTime(firstDayOfMonth);
        setFinalDateTime(addDays(today, 1));
        setTitle("DE " + generateTitleDate(firstDayOfMonth) + " A " + generateTitleDate(today))
        break;
      case 6:
        // Opción 'Todas las fechas con turnos'
        setInitialDateTime(today);
        const yest = generateFromDateCollapsible(new Date);
        yest.setDate(yest.getDate() - 1);
        setFinalDateTime(yest);
        setTitle("DESDE " + generateTitleDate(today))
        break;
      default:
        break;
    }

  };

  function generateFromDateCollapsible(date: Date) {
    const currentDate = new Date(date);

    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1;
    const day = currentDate.getDate();

    const formattedMonth = month < 10 ? `0${month}` : month;
    const formattedDay = day < 10 ? `0${day}` : day;

    const formattedDate = `${year}-${formattedMonth}-${formattedDay}T03:00:00.000Z`;

    return new Date(formattedDate);
  }

  function generateTitleDate(date: Date) {
    const weekDayName = weekDayNames[date.getDay()];
    const monthDay = date.getDate();
    const shortMonth = shortMonthNames[date.getMonth()];

    const formattedDate = `${weekDayName} ${monthDay.toString().padStart(2, '0')} ${shortMonth}`;
    return formattedDate;
  }

  function handleClickNotes(record: AppointmentsDTO, isnotes: boolean) {

    if (isnotes)
      openNotes({ patientCareQueue: record.patientcarequeue, sessionId: sessionId })
        .catch((err) => {
          console.error("error en openNotes: ", err);
        });
    else {

      openButtons(record)
        .catch((err) => {
          console.error("error en openButtons: ", err);
        });
    }

  }

  useEffect(() => {
    if (specialityId != -1) {
      setAppointments([])
      if (initialDateTime && finalDateTime) {
        if (collapsed)
          setShowDatePicker(false)
        else if (selected)
          setShowDatePicker(true)

        if (selected)
          setTitle(generateTitleDate(initialDateTime))

        getAppointmentListSpeciality(initialDateTime, finalDateTime, specialityId, showAppointments, type)
          .then((response) => {
            setAppointments(response);
          }).catch((error) => {
            console.error('Error en getAppointmentList: ', error);
          })

      }
    } else if (professionalId != -1) {
      setAppointments([])
      if (initialDateTime && finalDateTime) {
        if (collapsed)
          setShowDatePicker(false)
        else if (selected)
          setShowDatePicker(true)

        if (selected)
          setTitle(generateTitleDate(initialDateTime))

        getAppointmentList(initialDateTime, finalDateTime, professionalId, showAppointments, type)
          .then((response) => {
            console.log(getAppointmentList(initialDateTime, finalDateTime, professionalId, showAppointments, type));
            setAppointments(response);
          }).catch((error) => {
            console.error('Error en getAppointmentList: ', error);
          })

      }
    }
  }, [initialDateTime]);

  useEffect(() => {
    if (collapsed)
      setShowDatePicker(false)
    else if (selected)
      setShowDatePicker(true)

    if (selected)
      setTitle(generateTitleDate(initialDateTime))
  }, [collapsed]);

  return (
    <div className="viewContainer">
      {showDatePicker && (
        <InputDate
          label={intl.formatMessage({ id: 'Date' })}
          value={initialDateTime}
          onChange={(e: any) => {
            const formattedDate = generateFromDateCollapsible(e.value)
            setInitialDateTime(formattedDate);
            setFinalDateTime(addDays(formattedDate, 1))
          }}
        />
      )}
      <div>
        <Collapsible
          title={title}
          options={options}
          onSelectOption={handleSelectOption}
          collapsible={collapsed}
          setCollapsible={setCollapsed}
          defaultOptionId={2}>
        </Collapsible>
      </div>

      {appointments && (<div style={{ paddingLeft: '0px', height: collapsed ? 'calc(100vh - 80px)' : !showDatePicker ? 'calc(100vh - 330px)' : 'calc(100vh - 420px)' }} className="cards-container">

        {appointments.map((record: AppointmentsDTO) => (
          <TurnCard
            key={record.medereentity}
            record={record}
            handleClick={handleClickNotes}
          />
        ))}
      </div>)}

      {!appointments && (
        <div style={{ border: '1px solid #ccc' }} className="cards-container">
          <h1>{"No hay resultados"}</h1>
        </div>
      )}

    </div>
  )

}